import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import backend from "i18next-xhr-backend";

function getVersion() {
    const metas = document.getElementsByTagName('meta');

    for (let i = 0; i < metas.length; i++) {
        if (metas[i].getAttribute('name') === 'version') {
            return metas[i].getAttribute('content');
        }
    }

    return '';
}

i18n
    .use(backend)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        lng: document.documentElement.lang,
        fallbackLng: "pl",

        keySeparator: '.', // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        },

        backend: {
            loadPath: '/Script/Locales/{{lng}}/{{ns}}?v=' + getVersion(),
            crossDomain: false,
            withCredentials: false,
        }
    });

export default i18n;